import React from 'react'

const Resume = () => {

    return (

        <div className="page-container">
            <h3>resume</h3>
        </div>
    )
}

export default Resume